import styled from 'styled-components'
import { Copy } from '@stokr/components-library'
import { Section } from 'components/sto/Section'
import { useStoProject } from 'hooks/sto/useStoProject'
import { resolveSectionState } from 'models/stoSection'
import { stoColor, stoType } from 'constants/stoTheme'

const Description = styled.p`
  ${stoType.bodyText};
  margin: 0;
  color: ${stoColor.textPrimary};
  white-space: pre-wrap;
`

/** Figma's card here uses background/surface (#f8f8f8) rather than the shared white. */
const StyledSection = styled.div`
  > [data-sto-section='overview'] {
    background: ${stoColor.surfaceAlt};
  }
`

export const ProductOverview = () => {
  const { project, isPending, isError } = useStoProject()
  const description = project?.description?.trim()
  const state = resolveSectionState({ isPending, isError, data: description, isEmpty: (text) => !text })

  return (
    <StyledSection>
      <Section anchor="overview" title={<Copy id="stoPage.productOverview.title" />} state={state} elevated>
        {(text) => <Description>{text}</Description>}
      </Section>
    </StyledSection>
  )
}
